import { API } from '../config/config';
import html2pdf from 'html2pdf.js';

const extractApiErrorMessage = (error, fallbackMessage) => {
  const data = error?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.error) return data.error;
  return error?.message || fallbackMessage;
};

const getTicketPreview = async (storeId, idSales) => {
  const query = Array.isArray(idSales) ? idSales.join(',') : idSales;
  const response = await API.get(`/stores/${storeId}/ticket-preview`, { params: { idSales: query } });
  return response.data;
};

const printSales = async (storeId, idSales) => {
  const ids = Array.isArray(idSales) ? idSales : [idSales];
  const payload = {
    storeId,
    idSales: ids,
  };

  try {
    const response = await API.post('/print-preview', payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw new Error(extractApiErrorMessage(error, 'No se pudo enviar el trabajo de impresión.'));
  }
};

const downloadTicketPreviewAsPDF = async (storeId, idSalesCsv) => {
  const response = await API.get(`/stores/${storeId}/ticket-preview`, {
    params: { idSales: idSalesCsv },
    responseType: 'text',
    withCredentials: true,
  });

  if (response.status !== 200) {
    throw new Error('Error al obtener preview');
  }

  const html = response.data;
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();

  await new Promise((resolve) => setTimeout(resolve, 200));
  await html2pdf().from(doc.body).save(`ticket-${Date.now()}.pdf`);
  document.body.removeChild(iframe);
};

const getPrinterSettings = async (signal) => {
  const response = await API.get('/printer-settings', { signal });
  return response.data;
};

const getActivePrinter = async () => {
  const response = await getPrinterSettings();
  const printers = Array.isArray(response) ? response : [];
  return printers.find((printer) => printer.enabled);
};

const createPrinterSettings = async (data) => {
  const response = await API.post('/printer-settings', data);
  return response.data;
};

const updatePrinterSettings = async (id, data) => {
  const response = await API.put(`/printer-settings/${id}`, data);
  return response.data;
};

const deletePrinterSettings = async (id) => {
  const response = await API.delete(`/printer-settings/${id}`);
  return response.data;
};

const PrinterService = {
  getTicketPreview,
  printSales,
  downloadTicketPreviewAsPDF,
  getPrinterSettings,
  getActivePrinter,
  createPrinterSettings,
  updatePrinterSettings,
  deletePrinterSettings,
};

export default PrinterService;
